// extracted by mini-css-extract-plugin
export default {"root":"EditListingDevelopmentSituationsPanel_root__PLYj7","form":"EditListingDevelopmentSituationsPanel_form__pXjvh","title":"EditListingDevelopmentSituationsPanel_title__ywicc"};